/* Rheinkauf – Kopfbereich (Stand 05.10.2026)
 * 1. Großes Menü ab 1200 px (snippets/rk-megamenu.liquid): öffnet bei Maus und Tastatur.
 *    Tastatur: Fokus auf dem Menüpunkt öffnet das Feld, Tab führt hinein und am Ende weiter
 *    zum nächsten Menüpunkt, Pfeil nach unten springt hinein, Esc schließt (Fokus zurück auf
 *    den Menüpunkt). aria-expanded/aria-controls am Menüpunkt. Bilder werden vorab geladen (N8).
 *    Offene Aufklapper anderer Teile werden geschlossen (wie WSTND sections/header.liquid).
 * 2. Handy-Menü (snippets/navigation-drawer.liquid): Ebenen, Zurück, Esc, Fokus bleibt im
 *    offenen Menü; Bilder erst beim Öffnen laden (C9).
 * 3. Lupe im Kopf: auf großen Bildschirmen sichtbar, sobald das große Suchfeld aus dem
 *    Bild ist (html.rk-suche-weg, Regel in assets/rk-suche.css). Handy: immer sichtbar.
 * 4. Navigation immer einzeilig (H15): Passt sie nicht in die Zeile, bekommt <html> die
 *    Klasse rk-nav-eng und der Kopf zeigt den Menü-Knopf (Regeln in assets/rk-kopf.css).
 * Kein Modul-Code, keine Abhängigkeiten.
 */
(function () {
  'use strict';

  var DESKTOP = '(min-width: 1200px)';
  var FOKUSIERBAR = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

  /* Navigation zu schmal? (Klasse von navPruefen) */
  function navEng() {
    return document.documentElement.classList.contains('rk-nav-eng');
  }

  /* Sichtbare, fokussierbare Elemente in Dokumentreihenfolge */
  function fokusierbare(root) {
    if (!root) return [];
    return Array.prototype.filter.call(root.querySelectorAll(FOKUSIERBAR), function (el) {
      if (!el.getClientRects().length) return false;
      return window.getComputedStyle(el).visibility !== 'hidden';
    });
  }

  /* Bilder mit loading="lazy" sofort anfordern */
  function bilderLaden(root) {
    if (!root) return;
    Array.prototype.forEach.call(root.querySelectorAll('img[loading="lazy"]'), function (img) {
      img.loading = 'eager';
    });
  }

  function ereignis(name) {
    try {
      document.dispatchEvent(new CustomEvent(name));
    } catch (e) { /* sehr alte Browser */ }
  }

  /* ---------- 1. Großes Menü ---------- */
  var mega = null; // aktueller Zustand, von den einmal angemeldeten Dokument-Ereignissen genutzt

  function megaMenu() {
    var root = document.getElementById('rk-mega');
    if (!root || root.dataset.bereit) return;
    /* Theme-Editor: alte, bereits verschobene Fassung entfernen */
    Array.prototype.forEach.call(document.querySelectorAll('body > .rk-mega[data-bereit]'), function (alt) {
      if (alt !== root) alt.parentNode.removeChild(alt);
    });
    root.dataset.bereit = '1';
    document.body.appendChild(root);

    var desktop = window.matchMedia(DESKTOP);
    var zustand = {
      root: root,
      offen: null,
      zuTimer: null,
      aufTimer: null,
      bilderGeladen: false,
      unterdrueckt: null
    };
    mega = zustand;

    function vorladen() {
      if (zustand.bilderGeladen) return;
      zustand.bilderGeladen = true;
      bilderLaden(root);
    }

    function panelFuer(li) {
      var name = li.getAttribute('data-menu-item');
      var ps = root.querySelectorAll('[data-rk-mega]');
      for (var i = 0; i < ps.length; i++) {
        if (ps[i].getAttribute('data-rk-mega') === name) return ps[i];
      }
      return null;
    }

    function linkVon(li) {
      return li ? li.querySelector('.header__nav-link') : null;
    }

    function oben(li) {
      var kopf = li.closest('.header') || li.closest('header') || li.closest('.shopify-section') || li;
      return Math.max(0, Math.round(kopf.getBoundingClientRect().bottom));
    }

    function schliessen() {
      clearTimeout(zustand.aufTimer);
      clearTimeout(zustand.zuTimer);
      var o = zustand.offen;
      if (!o) return;
      o.panel.classList.remove('is-open');
      o.li.classList.remove('rk-aktiv');
      var a = linkVon(o.li);
      if (a) a.setAttribute('aria-expanded', 'false');
      root.classList.remove('is-open');
      root.setAttribute('aria-hidden', 'true');
      zustand.offen = null;
    }

    function oeffnen(li) {
      if (!desktop.matches || navEng()) return;
      var p = panelFuer(li);
      if (!p) {
        schliessen();
        return;
      }
      clearTimeout(zustand.zuTimer);
      if (zustand.offen && zustand.offen.li === li) return;
      if (zustand.offen) {
        zustand.offen.panel.classList.remove('is-open');
        zustand.offen.li.classList.remove('rk-aktiv');
        var alt = linkVon(zustand.offen.li);
        if (alt) alt.setAttribute('aria-expanded', 'false');
      }
      vorladen();
      /* Andere offene Aufklapper im Kopf schließen (Sofortsuche) */
      ereignis('rk:suche-schliessen');
      root.style.setProperty('--rk-mega-top', oben(li) + 'px');
      p.classList.add('is-open');
      li.classList.add('rk-aktiv');
      var a = linkVon(li);
      if (a) a.setAttribute('aria-expanded', 'true');
      root.classList.add('is-open');
      root.setAttribute('aria-hidden', 'false');
      zustand.offen = { li: li, panel: p };
    }

    function spaeterZu() {
      clearTimeout(zustand.zuTimer);
      zustand.zuTimer = setTimeout(schliessen, 180);
    }

    /* Fokus programmatisch auf den Menüpunkt, ohne das Feld wieder zu öffnen */
    function ruhigFokus(li) {
      var a = linkVon(li);
      if (!a) return;
      zustand.unterdrueckt = li;
      a.focus();
      setTimeout(function () { zustand.unterdrueckt = null; }, 0);
    }

    /* Nächstes fokussierbares Element im Kopf nach dem Menüpunkt (für Tab am Feldende) */
    function nachDem(li) {
      var kopf = li.closest('.header') || document;
      var alle = fokusierbare(kopf);
      var i = alle.indexOf(linkVon(li));
      return i > -1 ? alle[i + 1] || null : null;
    }

    zustand.schliessen = schliessen;
    zustand.esc = function () {
      if (!zustand.offen) return false;
      var li = zustand.offen.li;
      schliessen();
      ruhigFokus(li);
      return true;
    };
    zustand.positionieren = function () {
      if (zustand.offen) root.style.setProperty('--rk-mega-top', oben(zustand.offen.li) + 'px');
    };

    Array.prototype.forEach.call(document.querySelectorAll('.header__nav-item.has-dropdown'), function (li) {
      var p = panelFuer(li);
      if (!p) return;
      var a = linkVon(li);
      if (a) {
        a.removeAttribute('title');
        a.setAttribute('aria-haspopup', 'true');
        a.setAttribute('aria-expanded', 'false');
        if (p.id) a.setAttribute('aria-controls', p.id);
        a.addEventListener('keydown', function (e) {
          if (!desktop.matches || navEng()) return;
          if (e.key === 'ArrowDown' || (e.key === 'Tab' && !e.shiftKey && zustand.offen && zustand.offen.li === li)) {
            oeffnen(li);
            var f = fokusierbare(p)[0];
            if (f) {
              e.preventDefault();
              f.focus();
            }
          }
        });
      }
      li.addEventListener('mouseenter', function () {
        clearTimeout(zustand.zuTimer);
        clearTimeout(zustand.aufTimer);
        vorladen();
        zustand.aufTimer = setTimeout(function () { oeffnen(li); }, zustand.offen ? 0 : 90);
      });
      li.addEventListener('mouseleave', function () {
        clearTimeout(zustand.aufTimer);
        spaeterZu();
      });
      li.addEventListener('focusin', function () {
        if (zustand.unterdrueckt === li) return;
        oeffnen(li);
      });
    });

    /* Menüpunkte ohne Feld schließen ein offenes Feld beim Darüberfahren bzw. Fokussieren */
    Array.prototype.forEach.call(document.querySelectorAll('.header__nav-item:not(.has-dropdown)'), function (li) {
      li.addEventListener('mouseenter', spaeterZu);
      li.addEventListener('focusin', schliessen);
    });

    Array.prototype.forEach.call(root.querySelectorAll('.rk-mega__panel'), function (p) {
      p.addEventListener('mouseenter', function () { clearTimeout(zustand.zuTimer); });
      p.addEventListener('mouseleave', spaeterZu);
      p.addEventListener('keydown', function (e) {
        if (e.key !== 'Tab' || !zustand.offen || zustand.offen.panel !== p) return;
        var f = fokusierbare(p);
        if (!f.length) return;
        var li = zustand.offen.li;
        if (e.shiftKey && document.activeElement === f[0]) {
          e.preventDefault();
          ruhigFokus(li);
        } else if (!e.shiftKey && document.activeElement === f[f.length - 1]) {
          e.preventDefault();
          var ziel = nachDem(li);
          schliessen();
          if (ziel) ziel.focus();
        }
      });
      p.addEventListener('focusout', function (e) {
        var ziel = e.relatedTarget;
        if (!ziel) return;
        if (root.contains(ziel)) return;
        if (ziel.closest && ziel.closest('.header__nav-item')) return;
        spaeterZu();
      });
    });

    var schleier = root.querySelector('[data-rk-mega-zu]');
    if (schleier) {
      schleier.addEventListener('mouseenter', spaeterZu);
      schleier.addEventListener('click', schliessen);
    }
    if (desktop.addEventListener) desktop.addEventListener('change', schliessen);

    /* Auf großen Bildschirmen die Menübilder in einer ruhigen Minute vorladen,
       damit beim ersten Öffnen keine grauen Kacheln zu sehen sind (N8). */
    if (desktop.matches && !navEng()) {
      var spaeter = window.requestIdleCallback || function (cb) { return setTimeout(cb, 1500); };
      if (document.readyState === 'complete') {
        spaeter(vorladen);
      } else {
        window.addEventListener('load', function () { spaeter(vorladen); });
      }
    }
  }

  /* ---------- 2. Handy-Menü ---------- */
  var handy = null;

  function handyMenue() {
    var root = document.querySelector('[data-rk-nav]');
    if (!root || root.dataset.bereit) return;
    root.dataset.bereit = '1';
    var btn = root.querySelector('.rk-nav__btn');
    var panel = root.querySelector('.rk-nav__panel');
    if (!btn || !panel) return;
    var zurueck = panel.querySelector('[data-rk-zurueck]');
    var titel = panel.querySelector('[data-rk-titel]');
    var inhalt = panel.querySelector('.rk-nav__inhalt');
    var zuKnopf = panel.querySelector('[data-rk-zu]');

    /* Panel direkt an den body hängen: sonst hält der Kopfbereich (sticky, eigener
       Stapel) es fest, und Suchleiste oder Seite schieben sich darüber.
       Theme-Editor: alte, bereits verschobene Fassung vorher entfernen. */
    Array.prototype.forEach.call(document.querySelectorAll('body > .rk-nav__panel, body > .rk-nav__schleier'), function (alt) {
      if (alt !== panel) alt.parentNode.removeChild(alt);
    });
    document.body.appendChild(panel);
    var schleier = document.createElement('div');
    schleier.className = 'rk-nav__schleier';
    document.body.appendChild(schleier);
    var aktuell = 'start';

    function zeige(id, richtung, fokusAuf) {
      var ziel = panel.querySelector('[data-ebene="' + id + '"]');
      if (!ziel) return;
      var vorher = aktuell;
      Array.prototype.forEach.call(panel.querySelectorAll('[data-ebene]'), function (s) {
        s.hidden = s !== ziel;
        s.classList.remove('rk-rein-rechts', 'rk-rein-links');
      });
      if (richtung) {
        void ziel.offsetWidth;
        ziel.classList.add(richtung === 'vor' ? 'rk-rein-rechts' : 'rk-rein-links');
      }
      aktuell = id;
      titel.textContent = ziel.getAttribute('data-titel') || 'Menü';
      zurueck.hidden = id === 'start';
      zurueck.setAttribute('data-ziel', ziel.getAttribute('data-zurueck') || 'start');
      inhalt.scrollTop = 0;
      if (!fokusAuf) return;
      /* Fokus: vorwärts aufs erste Element der neuen Ebene, zurück auf den Knopf,
         der die verlassene Ebene geöffnet hatte */
      var f = null;
      if (richtung === 'zurueck') {
        f = ziel.querySelector('[data-rk-ziel="' + vorher + '"]');
      }
      if (!f) f = fokusierbare(ziel)[0];
      if (f) f.focus({ preventScroll: true });
    }

    function istOffen() { return panel.classList.contains('is-offen'); }

    function auf() {
      zeige('start');
      bilderLaden(panel);
      ereignis('rk:suche-schliessen');
      if (mega && mega.schliessen) mega.schliessen();
      panel.removeAttribute('inert');
      panel.setAttribute('aria-hidden', 'false');
      panel.classList.add('is-offen');
      schleier.classList.add('is-offen');
      document.documentElement.classList.add('rk-nav-offen');
      btn.setAttribute('aria-expanded', 'true');
      setTimeout(function () { if (zuKnopf) zuKnopf.focus({ preventScroll: true }); }, 50);
    }

    function zu(ohneFokus) {
      if (!istOffen()) return;
      panel.classList.remove('is-offen');
      schleier.classList.remove('is-offen');
      panel.setAttribute('aria-hidden', 'true');
      panel.setAttribute('inert', '');
      document.documentElement.classList.remove('rk-nav-offen');
      btn.setAttribute('aria-expanded', 'false');
      if (!ohneFokus && window.getComputedStyle(root).display !== 'none') btn.focus({ preventScroll: true });
    }

    schleier.addEventListener('click', function () { zu(); });
    btn.addEventListener('click', auf);
    if (zuKnopf) zuKnopf.addEventListener('click', function () { zu(); });
    zurueck.addEventListener('click', function () {
      zeige(zurueck.getAttribute('data-ziel') || 'start', 'zurueck', true);
    });
    panel.addEventListener('click', function (e) {
      var t = e.target.closest ? e.target.closest('[data-rk-ziel]') : null;
      if (t) {
        e.preventDefault();
        zeige(t.getAttribute('data-rk-ziel'), 'vor', true);
      }
    });
    panel.addEventListener('keydown', function (e) {
      if (!istOffen()) return;
      if (e.key === 'Escape') {
        e.preventDefault();
        if (aktuell !== 'start') {
          zeige(zurueck.getAttribute('data-ziel') || 'start', 'zurueck', true);
        } else {
          zu();
        }
        return;
      }
      if (e.key !== 'Tab') return;
      /* Fokus bleibt im offenen Menü (aria-modal) */
      var f = fokusierbare(panel);
      if (!f.length) return;
      var erst = f[0];
      var letzt = f[f.length - 1];
      if (e.shiftKey && (document.activeElement === erst || !panel.contains(document.activeElement))) {
        e.preventDefault();
        letzt.focus();
      } else if (!e.shiftKey && document.activeElement === letzt) {
        e.preventDefault();
        erst.focus();
      }
    });

    handy = { root: root, zu: zu, istOffen: istOffen };
  }

  /* ---------- 3. Lupe im Kopf, wenn das große Suchfeld nicht sichtbar ist ---------- */
  var sucheIo = null;

  function sucheBeobachten() {
    var html = document.documentElement;
    var leiste = document.querySelector('[data-rk-suche]');
    if (sucheIo) {
      sucheIo.disconnect();
      sucheIo = null;
    }
    if (!leiste || !('IntersectionObserver' in window)) {
      html.classList.add('rk-suche-weg');
      return;
    }
    var kopf = document.querySelector('.shopify-section-group-header-group .header');
    var kopfHoehe = kopf ? Math.round(kopf.getBoundingClientRect().height) : 0;
    sucheIo = new IntersectionObserver(function (eintraege) {
      var sichtbar = eintraege.some(function (e) { return e.isIntersecting; });
      html.classList.toggle('rk-suche-weg', !sichtbar);
    }, { rootMargin: '-' + kopfHoehe + 'px 0px 0px 0px' });
    sucheIo.observe(leiste.querySelector('.rk-suche__form') || leiste);
  }

  /* ---------- 4. Navigation einzeilig halten ---------- */
  function navPruefen() {
    var html = document.documentElement;
    var nav = document.querySelector('.header .header__nav');
    var liste = nav ? nav.querySelector('.header__nav-items') : null;
    var vorher = html.classList.contains('rk-nav-eng');
    if (!nav || !liste || !window.matchMedia(DESKTOP).matches) {
      if (vorher) {
        html.classList.remove('rk-nav-eng');
        ereignis('rk:nav-geprueft');
      }
      return;
    }
    /* Zum Messen kurz die normale Ansicht herstellen (kein sichtbares Flackern:
       Messen und Zurücksetzen passieren vor dem nächsten Zeichnen). */
    html.classList.remove('rk-nav-eng');
    var noetig = liste.scrollWidth;
    var platz = nav.clientWidth;
    var eng = platz > 0 && noetig > platz + 1;
    html.classList.toggle('rk-nav-eng', eng);
    if (eng !== vorher) ereignis('rk:nav-geprueft');
  }

  /* ---------- Ereignisse, die nur einmal angemeldet werden ---------- */
  var angemeldet = false;

  function einmalAnmelden() {
    if (angemeldet) return;
    angemeldet = true;

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      if (mega && mega.esc && mega.esc()) e.preventDefault();
    });
    /* Klick außerhalb von Menü und Navigation schließt das große Menü */
    document.addEventListener('click', function (e) {
      if (!mega || !mega.offen) return;
      var t = e.target;
      if (mega.root.contains(t)) return;
      if (t.closest && t.closest('.header__nav')) return;
      mega.schliessen();
    });
    /* Sofortsuche geöffnet → großes Menü zu */
    document.addEventListener('rk:suche-offen', function () {
      if (mega && mega.schliessen) mega.schliessen();
    });
    window.addEventListener('scroll', function () {
      if (mega && mega.positionieren) mega.positionieren();
    }, { passive: true });

    var t = null;
    window.addEventListener('resize', function () {
      if (mega && mega.schliessen) mega.schliessen();
      clearTimeout(t);
      t = setTimeout(function () {
        navPruefen();
        sucheBeobachten();
        /* Breiter Bildschirm: verschwindet der Menü-Knopf, wird ein offenes Handy-Menü geschlossen */
        if (handy && handy.istOffen() && window.getComputedStyle(handy.root).display === 'none') handy.zu(true);
      }, 150);
    });
    document.addEventListener('rk:nav-geprueft', function () {
      if (handy && handy.istOffen() && window.getComputedStyle(handy.root).display === 'none') handy.zu(true);
      if (navEng() && mega && mega.schliessen) mega.schliessen();
    });
    /* Erst mit geladener Schrift stimmt die Breite */
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(navPruefen);
    }
    window.addEventListener('load', navPruefen);
    /* Beim Zurückkehren aus dem Browser-Verlauf geschlossen starten */
    window.addEventListener('pageshow', function () {
      if (handy && handy.istOffen()) handy.zu(true);
      if (mega && mega.schliessen) mega.schliessen();
    });
  }

  function start() {
    navPruefen();
    megaMenu();
    handyMenue();
    sucheBeobachten();
    einmalAnmelden();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
  document.addEventListener('shopify:section:load', start);
})();
